import { render, staticRenderFns } from "./MailConfirmed.vue?vue&type=template&id=057391d4&scoped=true"
import script from "./MailConfirmed.vue?vue&type=script&lang=js"
export * from "./MailConfirmed.vue?vue&type=script&lang=js"
import style0 from "./MailConfirmed.vue?vue&type=style&index=0&id=057391d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057391d4",
  null
  
)

export default component.exports